<div class="title">اگر به مواد خاصی حساسیت دارید، مشخص کنید</div>
<div class="container">
  <app-radio-button
    *ngFor="let configButton of configButtons"
    [config]="configButton"
  ></app-radio-button>
</div>
